// #region imports

// --- HS Code
import { CommandTypes } from "../shared/command-types";
import { RespondentModel } from "./respondent-model";

// #endregion

export interface RespondentCommandModel {
  commandId: number;
  identifier: string;
  target: RespondentModel;
  commandType: CommandTypes;
  propertyName: string;
  newValue: any;
}
